<template>
  <div v-if="!state.loading">
    <div class="pgehd">
        <h2>Quiz List</h2>
        <div class="pgectr">
            <span class="pgebtn" @click="createnew">
                Create Quiz
            </span>
        </div>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>

        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="name" header="Name" />
        <PrimeColumn field="group" header="Total Groups" />
        <PrimeColumn field="date" header="Date" />
        <PrimeColumn header="Options">
            <template #body="slotProps">
                <div class="flex gap-2">
                <PrimeButton
                    label="Groups"
                    icon="pi pi-file-o"
                    class="p-button-rounded p-button-text"
                    @click="showGroups(slotProps.data)"
                />
                <PrimeButton
                    label="Participants"
                    icon="pi pi-users"
                    class="p-button-rounded p-button-text"
                    @click="participants(slotProps.data)"
                />
                </div>
            </template>
        </PrimeColumn>
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
  
    <ModalView
        :isVisible="state.createModal"
        :fixclose="true"
        @close="state.createModal = false">
        <DynamicForm :columns="2"
            :fields="createFields" @submit="addQuiz"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView>

</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref} from 'vue';
import { useRouter } from "vue-router";
import ModalView from "@/components/ModalView.vue";
import DynamicForm from "@/components/DynamicForm.vue";

export default {
    name:"AcademicResults",
    components:{ModalView,DynamicForm},
    setup(){
        const router = useRouter();
        const state=reactive({loading:true,createModal:false,submitting:false,errors:[],success:false })
        const list = ref([])
        const globalFilter=ref("")
        onMounted(() => {
            call({
                url:urls.quiz,
                data:{getQuizList:""},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        if (!Array.isArray(res.msg)) {
                            list.value = Object.values(res.msg)
                        } else {
                            list.value = res.msg
                        }
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        const createFields=ref([
            { name: "Create Quiz", number: "1",data: 
                [
                    { type: 'text', name: 'name', label: 'Name',
                        value: ""  },
                ]
            }
        ])

        function createnew(){
            state.createModal=true;
            state.submitting=false;
            state.errors=[];
        }

        
        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }

        function addQuiz(data){
            state.submitting=true;
            state.errors=[];
            data.addQuiz="";
            state.success=false;
            call({
                url:urls.quiz,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        setTable(res.msg)
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }

        function action(row,type){
            router.push({ name: 'resultsview', query: { stu: row.id, s:type } });
        }

        function showGroups(row){
            router.push({ name: 'quizgroup', params: { id: row.id} });
        }

        function participants(row){
            router.push({ name: 'quizparticipants', params: { id: row.id} });
        }
        
        return {list,globalFilter, state,action,createFields,createnew,addQuiz, showGroups, participants}
    }
}
</script>